import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import icons from "../lib/icons";


const IbanInput = (props) => {
  const { control, name, value, errors, className } = props;
  const numberReg = new RegExp("^[0-9]*$");

  const isSheba = true;

  const handleInputChange = (e, fieldIndex, length, onChange) => {
    const { value } = e.target;

    const inputs = document.querySelectorAll(`[name^="field-"]`);
    let updatedValue = Array.from(inputs)
      .map((input) => input.value)
      .join("");

    if (value.length <= 24 && numberReg.test(value)) onChange(updatedValue);

    // Update focus when the input is filled
    if (value.length > length && value.length !== 16) {
      const nextField = document.querySelector(
        `input[name=field-${fieldIndex + 1}]`
      );
      if (nextField) nextField.focus();
    }
  };

  const handleBackspace = (e, fieldIndex) => {
    if (
      e.key === "Backspace" &&
      e.target.value.length === 3 &&
      fieldIndex === 5
    ) {
      const prevField = document.querySelector(`input[name=field-4]`);

      if (prevField) prevField.focus();
    }
    if (e.key === "Backspace" && e.target.value.length === 0) {
      const prevField = document.querySelector(
        `input[name=field-${fieldIndex - 1}]`
      );

      if (prevField) prevField.focus();
    }
  };

  const handlePaste = (e, onChange) => {
    e.preventDefault();
    const pastedValue = e.clipboardData.getData("text").replace(/\s/g, "");

    if (isSheba && pastedValue.startsWith("IR")) {
      // Remove "IR" for Sheba if pasted
      onChange(pastedValue.slice(2));
    } else {
      onChange(pastedValue);
    }

    // Distribute the value across the fields
    const inputs = document.querySelectorAll(`[name^="field-"]`);
    let remainingValue = isSheba ? pastedValue.slice(2) : pastedValue;

    inputs.forEach((input) => {
      const length = parseInt(input.getAttribute("data-length"), 10);
      input.value = remainingValue.slice(0, length);
      remainingValue = remainingValue.slice(length);
    });
  };

  useEffect(() => {
    const firstField = document.querySelector(`input[name=field-1]`);
    if (isSheba && firstField) {
      firstField.focus();
      // Move cursor to end
      const length = firstField.value.length;
      firstField.setSelectionRange(length, length);
    }
  }, [isSheba]);

  useEffect(() => {
    const firstIbanField = document.querySelector(`input[name=field-5]`);
    if (value.length === 17 && firstIbanField) {
      firstIbanField.focus();
      // Move cursor to end
      const length = firstIbanField.value.length;
      firstIbanField.setSelectionRange(length, length);
    }
  }, [value]);

  return (
    <div
      className={`col-span-2 md:col-span-1 flex flex-col gap-2     ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        if (value.length < 2)
          document.querySelector(`input[name=field-1]`).focus();
      }}
    >
      <div className="flex gap-1  items-center  ">
        <button tabIndex={-1} className=" font-semibold text-[14px]  px-2   ">
          شماره شبا
        </button>
        {errors && <div className="error-text ">{errors?.message}</div>}
      </div>
      <div className="pb-2 text-[14px] md:text-[16px] outline-none rounded-v-md w-full    disabled:bg-neutral-10 disabled:border-none">
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, value } }) => {
            //console.log(value.length);
            const inputConfig = isSheba ? [2, 4, 4, 4, 4, 4, 2] : [4, 4, 4, 4];
            const splitValue = [];
            let currentIndex = 0;

            inputConfig.forEach((length) => {
              splitValue.push(value.slice(currentIndex, currentIndex + length));
              currentIndex += length;
            });

            return (
              <div
                className="w-full flex items-center gap-[2px] bg-white p-[10px] border-[1px] border-[#cccccc] rounded-[6px]"
                dir="ltr"
              >
                {isSheba && (
                  <img
                    src={icons.iban}
                    alt="info"
                    className="size-3 md:size-4 lg:size-5"
                  />
                )}
                <div className="flex gap-2">
                  {inputConfig.map((length, index) => (
                    <input
                      key={index}
                      style={{
                        textAlign: "start",
                        flex: length,
                        width: length * 11,
                      }}
                      className=" text-[14px] md:text-[16px] outline-none border-b-[0.5px] border-[#d8d0d0]   w-fit  disabled:border-none "
                      type="text "
                      inputMode="numeric"
                      maxLength={index === 6 ? length : null}
                      name={`field-${index + 1}`}
                      data-length={length}
                      value={splitValue[index] || ""}
                      onChange={(e) => {
                        handleInputChange(e, index + 1, length, onChange);
                      }}
                      onKeyDown={(e) => handleBackspace(e, index + 1)}
                      onPaste={(e) => {
                        if (numberReg.test(e.target.value)) {
                          //console.log(numberReg.test(e.target.value));
                          handlePaste(e, onChange);
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default IbanInput;
